import PeopleIcon from '@mui/icons-material/People'
import UserList from './UserList'

export default {
  list: UserList,
  icon: PeopleIcon,
  recordRepresentation: 'email',
}
